import axios from "axios";
import type { AxiosResponse } from "axios";
import type { Response } from "../types/axios";
import { message } from "ant-design-vue";

let base_url = "/";
if (
  process.env.NODE_ENV == "development" ||
  process.env.VUE_APP_BUILD == "test"
) {
  base_url = "http://testhrcenter-api.risfond.com/"; //本地起的假接口服务 连调时需要换成后端测试环境接口
} else {
  base_url = "https://bms-api.risfond.com/";
}
axios.defaults.baseURL = base_url;

axios.interceptors.request.use(
  (config) => {
    config.headers.Authorization = sessionStorage.getItem("token");
    config.headers["Content-Type"] = "application/json";
    //测试域名证书过期
    if(process.env.NODE_ENV == "development" || process.env.VUE_APP_BUILD == "test"){
      config.headers["X-XSS-Protection"] = "0";
    }
    return config;
  },
  (error) => {
    if (error.message.includes("timeout")) {
      // 判断请求异常信息中是否含有超时timeout字符串
      return Promise.reject(error); // reject这个错误信息
    }
    return Promise.reject(error);
  }
);

// 响应拦截器

axios.interceptors.response.use(
  (response: AxiosResponse<Response>) => {
    if (response.status === 200) {
      return Promise.resolve(response);
    } else if (response.status == 401) {
      message.warning("登录态失效，即将跳转登录页");
      const formalUlr = "https://staff.risfond.com/signin.aspx";
      const testUlr = "http://graystaff.risfond.com/signin.aspx";
      setTimeout(() => {
        if (
          process.env.VUE_APP_BUILD == "test" ||
          process.env.NODE_ENV == "development"
        ) {
          window.location.href = testUlr;
        } else {
          window.location.href = formalUlr;
        }
      }, 1500);
      return Promise.reject(response);
    } else {
      return Promise.reject(response);
    }
  },
  (error) => {
    if (error.response.status == 401) {
      const formalUlr = "https://staff.risfond.com/signin.aspx";
      const testUlr = "http://graystaff.risfond.com/signin.aspx";
      if (
        process.env.VUE_APP_BUILD == "test" ||
        process.env.NODE_ENV == "development"
      ) {
        window.location.href = testUlr;
      } else {
        window.location.href = formalUlr;
      }
    }
    if (error.response && error.response.status) {
      return Promise.reject(error.response);
    }
  }
);

// get 方法
export function get(url: string, params?: any): Promise<Response> {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

// post 方法
export function post(url: string, params?: any): Promise<Response> {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
}
//
export function applicationJson(
  url: string,
  params?: string
): Promise<Response> {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
}
